import { useCompanySettings } from '../queries/company';
import { useStore } from './useStore';

/**
 * Reads a per-company feature flag.
 *
 * The company settings query is the single source: companyStore holds the same
 * endpoint in a second, independently refreshed cache, so reading flags from
 * both makes menus and routes disagree until a reload.
 *
 * Components using this must be observers.
 */
export const useFeatureFlag = (feature: string) => {
  const { companyStore } = useStore();
  const companyId = companyStore.company?.id ?? '';
  const { data: companySettings, isLoading } = useCompanySettings(companyId);

  return {
    isEnabled: companySettings?.feature_flags?.[feature] === true,
    // A disabled query reports isLoading false, so without the id check a
    // caller would read "no company yet" as "flag off" and redirect away.
    isLoading: !companyId || isLoading
  };
};
